import React, { useEffect, useState } from "react"
import {
    Row,
    Col,
    Modal,
    ModalHeader,
    ModalBody
} from "reactstrap"
import { SuccessOk } from "configs/statusCode"
import { AvForm } from 'availity-reactstrap-validation';
import { toast } from "react-toastify"
import Select from "react-select";
import PropertyService from "services/Admin/PropertyService";
 
function AddToBuildingModal({ modal, toggle, type, setShouldGetData, ids ,buildingOptions,options, activeCanvasData}) {
    const [loading, setLoading] = useState(false)
    const [buildingOpttions, setBuildingOpttions] = useState([])
    const [formData, setFormData] = useState({
        selectedBuilding: null
    })

    useEffect(()=>{
        let dropOptions = options?.filter(res=> !!res?.name)?.map(item=>{
            return {
                ...item,
                label: item?.name
            }
        })
        setBuildingOpttions(buildingOptions)
    },[])

    const handleValidSubmit = () => {
        if(!formData?.selectedBuilding){
            toast.error("Select Building First")
            return
        }
        let data ={
            unit_ids: ids
        }
        if(!!formData?.selectedBuilding?.id){
            data['building_id']= formData?.selectedBuilding?.id
            new PropertyService().addToBuilding(data).then(res=>{
                if(res.status == SuccessOk){
                    toast.success("Properties Added to Building Successfully")
                    setShouldGetData(prev=> !prev)
                    toggle()
                    return
                }
            })
        } else{
            new PropertyService().addToStandAlone(data).then(res=>{
                if(res.status == SuccessOk){
                    toast.success("Properties Added to StandAlone Successfully")
                    setShouldGetData(prev=> !prev)
                    toggle()
                    return
                }
            })
        }
    }
    
    return (
        <Modal isOpen={modal} toggle={toggle} className="scrollbar-container mt-5">
            <AvForm
                className='form-horizontal'
                onValidSubmit={(e, v) => {
                    handleValidSubmit(e, v)
                }}>
                <ModalHeader toggle={toggle}>
                    Add Properties to Building
                 </ModalHeader>
                <ModalBody>
                    <Row>
                        <Col md={12}>
                            <label>Select Building</label>
                            <Select
                                placeholder='Select'
                                options={type === 'toBuilding' ? buildingOpttions : [{label: 'null', value: null, id: null}, ...buildingOpttions?.filter(res=> res?.id !== activeCanvasData?.constrains?.id)]}
                                onChange={data => {
                                    setFormData({ ...formData, selectedBuilding: data })
                                    setLoading(false)
                                }}
                                value={formData?.selectedBuilding}
                            />
                        </Col>
                    </Row>

                </ModalBody>

                <Row >
                        {/* <Col md={6} className='w-100'>
                            <button
                            onClick={toggle}
                            type='button'
                            className='btn btn-secondary w-100'>

                            Cancel
                            </button>
                        </Col> */}
                        <Col md={6}></Col>
                        <Col md={6} className='mt-3'>
                            <button
                            type='submit'
                            disabled={loading}
                            className='btn btn-success w-100'>
                            Submit
                            </button>
                        </Col>
                    </Row>
            </AvForm>
        </Modal>

    )
}

export default AddToBuildingModal
